import { Subject, takeUntil } from 'rxjs';
import { RoleService } from './role.service';

export interface RoleWrapperState {
  isAdminUser: boolean;
}

export function updateRoleWrapperState(state: RoleWrapperState, roleService: RoleService): void {
  state.isAdminUser = roleService.resolveIsAdmin();
}

/**
* Initializes the role wrapper state and sets up subscriptions to update it when the current user role changes.
* @example
* initializeRoleWrapper(state, roleService, destroy$)
* undefined
* @param {RoleWrapperState} state - The RoleWrapperState object to be updated with role information.
* @param {RoleService} roleService - Service providing currentUserRole$ observable and role-related utilities.
* @param {Subject<void>} destroy$ - Observable used to complete subscriptions when the wrapper is destroyed.
* @returns {void} No return value.
**/
export function initializeRoleWrapper(
  state: RoleWrapperState,
  roleService: RoleService,
  destroy$: Subject<void>
): void {
  updateRoleWrapperState(state, roleService);

  roleService.currentUserRole$
    .pipe(takeUntil(destroy$))
    .subscribe(() => {
      updateRoleWrapperState(state, roleService);
    });

  setTimeout(() => {
    updateRoleWrapperState(state, roleService);
  }, 100);
}

export function destroyRoleWrapper(destroy$: Subject<void>): void {
  destroy$.next();
  destroy$.complete();
}
